import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/contact'
// Modules
import contact from './contact'

const initialState = () => ({
    contacts: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        contacts: state => state.contacts.data,
        pagination: state => state.contacts.pagination
    },
    actions: {
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listContacts: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listContacts(params)
                const contacts = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }
                commit(mutationTypes.SET_CONTACTS, contacts)
                return contacts
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetContacts: ({commit}) => commit(mutationTypes.RESET_CONTACTS)
    },
    modules: {
        contact
    },
    mutations: {
        [mutationTypes.RESET_CONTACTS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_CONTACTS]: (state, data) => state.contacts = data
    }
}
